// extracted by mini-css-extract-plugin
module.exports = {"bold-text":"DetailsModal_bold-text__2O7XL","button":"DetailsModal_button__3V3xy"};